import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ContactsPage, type ContactsSearch } from '../../features/B2a/contacts-page';

const search = z.object({
  q: z.string().optional().catch(undefined),
  /** client id, `_team` (NIVISION team) or `_none` (no client) */
  client: z.string().optional().catch(undefined),
  status: z.enum(['active', 'blocked']).optional().catch(undefined),
  /** '1' = saved in the phone's address book only */
  saved: z.enum(['1']).optional().catch(undefined),
  /** group id: the group's active members only */
  group: z.string().optional().catch(undefined),
});

/** #/contacts — people the clients number talks to: search, filter, add, edit, block / unblock. Lane B2a. */
export const Route = createFileRoute('/_app/contacts')({
  validateSearch: search,
  component: Contacts,
});

function Contacts() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return <ContactsPage search={s} setSearch={(next: ContactsSearch) => void navigate({ search: next, replace: true })} />;
}
